import CloseIcon from '@mui/icons-material/Close';
import { Box,Button,Dialog,DialogActions,DialogContent,DialogTitle,Tab,Tabs } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import AttToken from "../../../../helpers/attToken";
import { trackEventMatomo } from "../../../../helpers/matomo";
import checklistStyle from "../../../../service/checklistStyle";
import queryClient from "../../../../service/query";
import { TabPanelProps } from "../../../../types/helpers/types";
import type { modeloStyleType } from "../../../../types/print-template/types";
import { initialObjectToSend } from "../../ChecklistStyle";
import StyleConfig from "./StyleConfig";
import StyleFillModal from "./StyleFillModal";

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}


type props = {
  editing: boolean,
  setEditing: Function,
  openModal: boolean,
  setOpenModal: Function,
  setObjectToEdit: Function,
  objectToEdit: modeloStyleType,
};

const modelService = new checklistStyle();

export default function EditFormDeslogadoTabs({
  editing,
  setEditing,
  openModal,
  setOpenModal,
  objectToEdit,
  setObjectToEdit
}: props) {
  const [value, setValue] = useState<number>(0);

  function handleChange(_event: React.SyntheticEvent, newValue: number) {
    setValue(newValue);
  };

  const { t } = useTranslation('translation');

  const { mutate, isPending } = useMutation({
    mutationKey: ['EDIT_MODEL'],
    mutationFn: async () => {
      try {
        const token = await AttToken();
        if (!token) throw new Error('Token not found');
        const promise = toast.promise(async () => {
          if (!editing) {
            const response = await modelService.create(token, objectToEdit);
            if (!response) throw new Error('Error creating model');
            return response;
          } else {
            const response = await modelService.edit(token, objectToEdit);
            if (!response) throw new Error('Error editing model');
            return response;
          }
        }, {
          pending: editing ? `${t('toast.editingTemplate')}` : `${t('toast.creatingNewTemplate')}`,
          success: editing ? `${t('toast.templateUpdated')}` : `${t('toast.templateCreatedSuccess')}`,
          error: editing ? `${t('toast.errorEditingTemplate')}` : `${t('toast.errorCreatingTemplate')}`
        });
        return promise;
      } catch (error) {
      }
    },
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ['GET_MODELS'] });
      setObjectToEdit(initialObjectToSend);
      setOpenModal(false);
      setEditing(false);
    },
    onError: (error) => {
      console.error('Error in mutation:', error);
    }
  });

  const close = () => {
    setObjectToEdit(initialObjectToSend);
    setOpenModal(false);
    setEditing(false);
    trackEventMatomo('Configurar impressões form deslogado', 'click', 'button', 'cancela');
  };

  const submit = () => {
    trackEventMatomo('Configurar impressões form deslogado', 'click', 'button', 'salva');
    mutate();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={openModal}
      onClose={close}
      scroll={'paper'}
    >
      <DialogTitle>Criar layout para formulário web</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={close}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers={true}>
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab label='Editar visual' value={0} />
              <Tab label="Editar configurações" value={1} />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <StyleFillModal
              setObjectToEdit={setObjectToEdit}
              objectToEdit={objectToEdit}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <StyleConfig
              setObjectToEdit={setObjectToEdit}
              objectToEdit={objectToEdit}
            />
          </CustomTabPanel>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={submit}
          disabled={
            isPending
            || !objectToEdit.associatedChecklists?.length}>
          {t('save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

